<template>
  <div class="cmp-catalog-releases-releases_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="search" style="max-width: 500px">
      
        <InputField
          :value="searchString"
          :placeholder="'Search'"
        
          :config="{
            borderStyle: 'bottom',
            width: '124px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
   

        <Dropdown
            :options="statusTV"
            style="margin-top:-1px;margin-left:20px"
            :placeholder="'Status'"
            deselect
            borderbottom
            v-on:selectedChange="e => onDropdownChange('status', e)"
          ></Dropdown>
        
    
        
      </div>

      <div class="right-container ut-colcen">
        <div class="ut-flex">

          <button
            class="dt-button v5 s8"
           
          >
            {{ $t("Upload Payments") }}
          </button>
        </div>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable
        id="catalog-releases-releases_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="items"
        @scrollnext="onReleasesNext"
        
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('account_name')">
                <span>{{item['account_name']}} </span>
            </td>
            <td v-bind="tdcon('status')">
              <span>{{ item["status"] }}</span>
            </td>
            <td v-bind="tdcon('coding_date')">
              <span>{{ item["coding_date"] }}</span>
            </td>
            <td v-bind="tdcon('coding_file')">
                  <span>{{ item["coding_file"] }}</span>
            </td>
            <td v-bind="tdcon('currency')">
                <span>{{ item["currency"] }}</span>   
            </td>
        
            <td v-bind="tdcon('amount')">
                <span>{{ item["amount"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
                 <div class="dt-icon-container">
                        <img
                           @click.stop="(e) => onEditPayments(item)"
                            src="static/icons/edit.svg"
                            class="dt-icon v5 s2"
                        />
                </div>
            </td>
            <td v-bind="tdcon('matching_date')">
              <span>{{ item["matching_date"] }}</span>
           
                
            </td>
             <td v-bind="tdcon('payment_amount')">
                <span>{{ item["payment_amount"] }}</span>
            </td>
       
            
          </tr>
        </template>
      </NTable>
  
    </div>
 
  <ModalContainer  @cancelled="onCancel" :modalKey="'editPayments'" :width="'400'">
      <EditPayments  @cancelled="onCancel" />
  </ModalContainer>
   
    
  
  </div>
</template>

<script>
// import Modal from '../../../../dt-plugins/modal/modal';
import { RoyaltyStoreNamespace as storeNS } from "../../store";
//import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
// import {
//   distinctUntilChanged,
//   debounceTime,
// } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

// import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { createModalMixin ,closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";
//import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import ShopManagement from "./shop-management";
import ConfirmRoyalty from './confirm-royalty-modal'; 
import CheckContract from './check-contracts-modal';
import EmailStatement from './email-statements-modal';
import BatchStatement from './batch-statement-modal';
import EditPayments from './edit-payment.vue';
// import FileDownload from "js-file-download";

//import AdvanceSearch from './advance-search'




import { subscribeSubject } from '../../../../utility';

// import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
// import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";


// import {
//   createTV,
//   tv,
// } from "../../../../models/text-value.model";

import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
import { statementGetters } from '../../store/statement/getters';
import { statementActions } from '../../store/statement/actions';
// import { statementServices } from '../../services/statements/statements.service';

// import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
// export const releaseListAdvancedSearchConfig = createAdvancedSearchConfig(
//   {
//     searchConfigStringKeys: [
      
//       "artist",
//       "title",
//       "start_date",
//       "end_date",
//       "indentifier",
//       "release_status",
//       "label_id",
//       "release_type",
//     ],
//     searchConfigTVMap: [
//       ["label_id", "labelsTV"],
//       ["release_type", "releaseTypeTV"],
//       ["release_status", "releaseStatusesTV"],
    
//     ],
//     // booleanSearchKeyLabelMap: {
//     //   barcode_catalog_error: "Barcode Error",
//     // },
//   }
// );

export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    ShopManagement,
    ConfirmRoyalty,
    CheckContract,
    EmailStatement,
    EditPayments,
    BatchStatement
    //AdvanceSearch,
   
  },
  mounted: function () {
      
      this.fetchData();
        //this.fetchListReset();
    // this[ActionTypes.ReleasesCatalogData.FETCH.ALL]();
     subscribeSubject(this, this.subjectSearchSubject, searchString => {
        
        console.log("STRING SER", searchString);
        this.fetchData();
       
      })

  },
  data: function () {
    return {
      startRow: 0,
      subjectSearchSubject: new Subject(),
      searchResult:[],
      limit_start: 0,
      limit_end: 100,
      searchString: "",
      searchStatus:"",
      defaultConfig: defaultConfig,
         searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search
    };
  },
   mixins: [
    
    // createLDTHost(LDTConfig),
    
    
    createModalMixin("emailStatement"),
    createModalMixin("checkContracts"),
    createModalMixin("confirmRoyalty"),
    createModalMixin("shopManagement"),
    createModalMixin("batchStatement")
    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
    
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    // ...mapGetters(storeNS, {
    //   releasesCatalogData: "releasesCatalogData",
      
     
    // }),
    ...mapGetterObject(storeNS,statementGetters),

    statusTV:function(params) {
      return [
        {text:"Paid",value:"paid"},
        {text:"Open",value:"open"},
        {text:"Requested",value:"requested"},
      ];
    },


    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
      });
    },
    items: function() {
        return this.statementPaymentData?.payments ||[]
    },
    list: function() {
      if(this.statementPaymentData && this.searchString.length==0){
        return this.statementPaymentData.payments;
      }else{
        return this.searchResult
      }
      return [];
    },

    contactHeaders: function () {
      return [
        createTableHeader("account_name", {  }),
        createTableHeader("status", { }),
        createTableHeader("coding_date", { }),
        createTableHeader("coding_file", { }),
        createTableHeader("currency", { }),
      
        createTableHeader("amount", {  }),
        createTableHeader("options", {  text:"Input Date",mw:60}),
        createTableHeader("matching_date", {  }),
        createTableHeader("payment_amount", {  }),
      ];
    },
    filter: function () {
      const no_filter_selected = Object.values(
        this.searchFilter
      )?.every((e) => !e);

      let searchType = this.searchType;
      if (!no_filter_selected && this.searchType == "none") {
        searchType = "release__standard_search";
      }

      return {
        searchType,
        no_filter_selected,

        str: this.searchString,

        start: this.start,
        row_count: this.row_count,

        ...this.searchFilter,
       // barCodeCatalogError: this.barCodeCatalogError ? 1 : 0,
      };
    },
  },
  methods: { 
   ...mapActionObject(storeNS, statementActions),


    fetchData: function () {
     //this[ActionTypes.ReleaseList.FETCH.ALL]({});
    //  this[ActionTypes.StatementList.FETCH.ALL]({ believe_special:this.$store.getters.account.believe_special, });
    this[ActionTypes.StatementPayment.FETCH.ALL]({ limit_start:this.limit_start,limit_end:this.limit_end,search_str:this.searchString,search_status:this.searchStatus });
    
    },

    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
  
      this.subjectSearchSubject.next(this.searchString);
    },
 
   
    closeModal:function(){
       closeModalRoute(this);
    },
    onTextFieldChange:function(event,item){
        console.log(event,item)
        //const payload={ kVal:item.royalty_period_id ,name:event.name,value:event.value}
        //this[ActionTypes.StatementList.UPDATE.SINGLE](payload);
    },
    onReleasesNext:function(){

    },
    onCancel: function () {
     closeModalRoute(this);
    },

    onDropdownChange:function(name,e){
        this.searchStatus=e.value;
        this.fetchData();
    },

    onEditPayments:function(){
      this.$router.push({
        ...this.$route,
        query: {
          modal: "edit_payments",
        },
      });
    }


    
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>